import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Layout from '@components/common/Layout';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatPagination from '@components/common/satUI/SatPagination';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import UnavailableListBox from '@components/management/system/product/UnavailableListBox';

import {
    showModal,
    getHqListByChannel,
    getAgencyListByHq,
  } from '@store/actions/commonAction';

import {
    getCommonCodeDtlList,
    getPrdtByChannel,
    getProdSaleImpsAgncRegList,
    getProdSaleQuitMethodCd,
    saveProdSaleImpsAgnc,
    getProdSaleImpsAgncRegListClear,
} from '@store/actions/managementProductAction';


const LEFT_COLUMN_RENDER = {
    "01" : (onLeftChkChange, onHeaderCheckboxChange, leftAllCheck, leftChkRow) => [
        {title:'채널',key:'orgChnlNm',dataIndex:'orgChnlNm'},
        {title:'leftChkBox',width:'40px',key:'',dataIndex:'', render : (value, row)=>(
            <div className='check-wrap chk-style' key={`${row?.rowIndex}_${row?.hqCd}_${row?.agncCd}`}>
                <input type="checkbox" name="" id={`chk_${row.rowIndex}`}
                    onChange={(e) => onLeftChkChange(e, row)}
                    value={row?.orgChnlCd}
                    checked={leftChkRow.filter(item=>item.rowIndex === row.rowIndex).length > 0}
                />
                <label htmlFor={`chk_${row.rowIndex}`}></label>
            </div>
        ), customHeader:(column)=>(
            <div className='check-wrap chk-style' key={`title_${column.title}`}>
                <input type='checkbox' name='' id='chk_all3'
                    onChange={(e) => onHeaderCheckboxChange(e, column)}
                    checked={leftAllCheck}
                />
                <label htmlFor='chk_all3'></label>
            </div>
        )},
    ],
    "02" : (onLeftChkChange, onHeaderCheckboxChange, leftAllCheck, leftChkRow) => [
        {title:'채널',key:'orgChnlNm',dataIndex:'orgChnlNm'},
        {title:'본부',key:'hqCdNm',dataIndex:'hqCdNm'},
        {title:'leftChkBox',width:'40px',key:'',dataIndex:'',render:(value, row)=>(
            <div className="check-wrap chk-style" key={`${row?.rowIndex}_${row?.hqCd}_${row?.agncCd}`}>
                <input type="checkbox" name="" id={`chk_${row.rowIndex}`}
                    onChange={(e) => onLeftChkChange(e, row)}
                    checked={leftChkRow.filter(item=>item.rowIndex === row.rowIndex).length > 0}
                />
                <label htmlFor={`chk_${row.rowIndex}`}></label>
            </div>
        ), customHeader:(column)=>(
            <div className='check-wrap chk-style' key={`title_${column.title}`}>
                <input type='checkbox' name='' id='chk_all3'
                    onChange={(e) => onHeaderCheckboxChange(e, column)}
                    checked={leftAllCheck}
                />
                <label htmlFor='chk_all3'></label>
            </div>
        )}
    ],
    "03" : (onLeftChkChange, onHeaderCheckboxChange, leftAllCheck, leftChkRow) => [
        {title:'채널',key:'orgChnlNm',dataIndex:'orgChnlNm'},
        {title:'본부',key:'hqCdNm',dataIndex:'hqCdNm'},
        {title:'지점',key:'agncCdNm',dataIndex:'agncCdNm'},
        {title:'leftChkBox',width:'40px',key:'',dataIndex:'',render:(value, row)=>(
            <div className="check-wrap chk-style" key={`${row?.rowIndex}_${row?.hqCd}_${row?.agncCd}`}>
                <input type="checkbox" name="" id={`chk_${row.rowIndex}`}
                    onChange={(e) => onLeftChkChange(e, row)}
                    checked={leftChkRow.filter(item=>item.rowIndex === row.rowIndex).length > 0}
                />
                <label htmlFor={`chk_${row.rowIndex}`}></label>
            </div>
        ), customHeader:(column)=>(
            <div className='check-wrap chk-style' key={`title_${column.title}`}>
                <input type='checkbox' name='' id='chk_all3'
                    onChange={(e) => onHeaderCheckboxChange(e, column)}
                    checked={leftAllCheck}
                />
                <label htmlFor='chk_all3'></label>
            </div>
        )}
    ]
}

const RIGHT_COLUMN_RENDER = (onRightChkChange, onHeaderCheckboxChange, rightAllCheck, rightChkRow) => [
    {title:'상품코드',key:'prodCd',dataIndex:'prodCd'},
    {title:'상품명',key:'prodNm',dataIndex:'prodNm'},
    {title:'rightChkBox',width:'40px',key:'',dataIndex:'',render:(value, row)=>{
        if(row.saleQuitProcMethdCd === 'N'){
            return (
                <div className='check-wrap chk-style' key={`${row.prodCd}_${row.prodNm}_${row.rowIndex}`}>
                    <input type="checkbox" name="" id={`chk_all_${row.rowIndex}`}
                        onChange={(e) => onRightChkChange(e, row)}
                        checked={rightChkRow.filter(item=>item.rowIndex === row.rowIndex).length > 0}
                    />
                    <label htmlFor={`chk_all_${row.rowIndex}`}></label>
                </div>
            )
        }
        else{
            return (
                <div className='check-wrap chk-style' key={`${row.prodCd}_${row.prodNm}_${row.rowIndex}`}>
                    <input type="checkbox" name="" id={`chk_all_${row.rowIndex}`} disabled />
                    <label htmlFor={`chk_all_${row.rowIndex}`}></label>
                </div>
            )
        }
    }, customHeader:(column)=>(
        <div className='check-wrap chk-style' key={`title_${column.title}`}>
            <input type='checkbox' name='' id='chk_all4'
                onChange={(e) => onHeaderCheckboxChange(e, column)}
                checked={rightAllCheck}
            />
            <label htmlFor='chk_all4'></label>
        </div>
    )},
]


const ManagementSystemUnavailableReg = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { 
        commonCodeDtl,
        salempsAgncReged,
        saleImpsAgncReg,
        prodSaleQuitMethod,
    } = useSelector(state => state.managementProductReducer);

    const { 
        hqList,
        agencyList
    } = useSelector(state => state.commonReducer);

    // listbox info
    const [channel, setChannel] = useState([]);
    const [hq, setHq] = useState([]);
    const [agency, setAgency] = useState([]);
    const [isHqChkAll, setIsHqChkAll] = useState(false);
    const [saleList, setSaleList] = useState([]);

    // left info
    const [leftSrchVal, setLeftSrchVal] = useState({
        orgChnlCd : '00',
        hqCd : '00',
        agncCd : '00',
    })
    const [leftGridCol, setLeftGridCol] = useState('01');
    const [leftGrid, setLeftGrid] = useState([]);
    const [leftChkRow, setLeftChkRow] = useState([]);
    const [leftAllCheck, setLeftAllCheck] = useState(false);

    // right info
    const [rightSrchVal, setRightSrchVal] = useState({
        orgChnlCd : '',
        prodGrpCd:'',
        prodNm:'',
        hqCd : '',
        agncCd : '',
    })
    const [rightGrid, setRightGrid] = useState([]);
    const [rightAllCheck, setRightAllCheck] = useState(false);
    const [rightChkRow, setRightChkRow] = useState([]);

    const [saveInfo, setSaveInfo] = useState({
        orgChnlCd : '',
        prodGrpCd:'',
        prodNm:'',
        hqCd : '',
        agncCd : '',
        saleQuitStrtDd : '',
        saleQuitEndDd : '',
        saleQuitProcMethdCd : '',
        saleQuitRsn : '',
    })

    useEffect(()=>{
        return () => {
            dispatch(getProdSaleImpsAgncRegListClear());
        }
      }, [])

    // 채널정보 조회
    useEffect(()=>{
        dispatch(getCommonCodeDtlList({
            cdTyId : "ORG_CHNL_CD"
        }))
    }, [])
    // 판매불가상품 사유 조회
    useEffect(()=>{
        dispatch(getProdSaleQuitMethodCd({
            cdTyId : "SALE_QUIT_PROC_METHD_CD"
        }))

        // const tmp = [
        //     {saleQuitProcMethdCd:'01',saleQuitProcMethdNm:'상품제한'},
        //     {saleQuitProcMethdCd:'02',saleQuitProcMethdNm:'청약제한'},
        // ]
        // setProdSaleQuitMethod(tmp)
    }, [])
    // 채널정보 조회 후 채널 리스트박스 데이터 구성
    useEffect(()=>{
        let tmp = [...commonCodeDtl];
        tmp.forEach((item, index)=>{
            tmp[index].val = item.cdVal;
            tmp[index].nm = item.cmnCdNm
        })

        setChannel(tmp);
    }, [commonCodeDtl])
    // 채널에 따른 본부 조회 후 본부 리스트박스 데이터 구성
    useEffect(()=>{
        let tmp = [...hqList];
        tmp.forEach((item, index)=>{
            tmp[index].val = item.hqCd;
            tmp[index].nm = item.hqNm
        })

        setHq(tmp);
    }, [hqList])
    // 채널,본부에 따른 지점 조회 후 지점 리스트박스 데이터 구성
    useEffect(()=>{
        let tmp = [...agencyList];
        tmp.forEach((item, index)=>{
            tmp[index].val = item.agncCd;
            tmp[index].nm = item.agncNm
        })

        setAgency(tmp);
    }, [agencyList])

    useEffect(()=>{
        let tmpHqCd = [];
        let tmpAgncCd = [];

        leftChkRow.forEach((item) => {
            tmpHqCd.push(item.hqCd);
            tmpAgncCd.push(item.agncCd);
        })

        setSaveInfo({
            ...saveInfo,
            ['orgChnlCd'] : leftSrchVal.orgChnlCd,
            ['hqCd'] : tmpHqCd.join(','),
            ['agncCd'] : tmpAgncCd.join(',')
        })
    }, [leftChkRow])

    // 좌측 채널선택 후 좌측 조회 클릭 시 상품군 목록 조회
    useEffect(()=>{
        let tmp = [...salempsAgncReged.prdtList];
        tmp.forEach((item, index)=>{
            tmp[index].val = item.saleProdGrpCd;
            tmp[index].nm = item.saleProdGrpNm;
        })
        setSaleList(tmp);
    }, [salempsAgncReged.prdtList])

    // 우측 그리드 판매불가상품 목록 조회
    useEffect(()=>{
        let tmp = [...saleImpsAgncReg.list];
        setRightGrid(tmp);

    }, [saleImpsAgncReg])

    // 리스트박스에 따른 좌측선택 값 세팅
    const setSearchValBySelect = ({target, val}) => {
        if(target === 'orgChnlCd'){
            setLeftSrchVal({
                ...leftSrchVal,
                [target] : val,
                ['hqCd'] : '00',
                ['agncCd'] : '00',
            })
            setRightSrchVal({
                ...rightSrchVal,
                [target] : val,
                ['hqCd'] : '00',
                ['agncCd'] : '00',
            })
        }
        else if(target === 'hqCd'){
            setLeftSrchVal({
                ...leftSrchVal,
                ['hqCd'] : val,
                ['agncCd'] : '00',
            })
            setRightSrchVal({
                ...rightSrchVal,
                ['hqCd'] : val,
                ['agncCd'] : '00',
            })
        }
        else{
            setLeftSrchVal({
                ...leftSrchVal,
                ['agncCd'] : val,
            })
            setRightSrchVal({
                ...rightSrchVal,
                ['agncCd'] : val,
            })
        }
    }

    // 좌측그리드 조회
    const onLeftSearch = () => {
        // 이전 체크된 값들 초기화
        setLeftChkRow([]);
        setLeftAllCheck(false);

        if(leftSrchVal.orgChnlCd === '' || leftSrchVal.orgChnlCd === '00'){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '채널을 선택해주세요.',
            }))
            return;
        }
        else{
            // 채널o, 본부all, 지점x
            if(leftSrchVal.hqCd === '' && leftSrchVal.agncCd === '00'){
                // orgChnlNm : '',
                // hqCdNm :''
                let tmp = [...hq];
                tmp.forEach((item)=>{
                    item.orgChnlCd = leftSrchVal.orgChnlCd,
                    item.orgChnlNm = commonCodeDtl.filter(cd => cd.cdVal === leftSrchVal.orgChnlCd)[0].cmnCdNm;
                    item.hqCd = item.hqCd;
                    item.hqCdNm = item.hqNm;
                })
                setLeftGrid(tmp)
                setLeftGridCol('02');
            }
            // 채널o, 본부o, 지점x
            else if(leftSrchVal.hqCd !== '' && leftSrchVal.hqCd !== '00' && leftSrchVal.agncCd === '00'){
                setLeftGrid([{
                    orgChnlCd:leftSrchVal.orgChnlCd,
                    orgChnlNm:commonCodeDtl.filter(cd => cd.cdVal === leftSrchVal.orgChnlCd)[0].cmnCdNm,
                    hqCd:leftSrchVal.hqCd,
                    hqCdNm:hq.filter(cd => cd.hqCd ===leftSrchVal.hqCd)[0].hqNm,
                }])
                setLeftGridCol('02');
            }
            // 채널o, 본부o, 지점all
            else if(leftSrchVal.hqCd !== '' && leftSrchVal.hqCd !== '00' && leftSrchVal.agncCd === ''){
                let tmp = [...agency];
                tmp.forEach((item)=>{
                    item.orgChnlCd = leftSrchVal.orgChnlCd,
                    item.orgChnlNm = commonCodeDtl.filter(cd => cd.cdVal === leftSrchVal.orgChnlCd)[0].cmnCdNm;
                    item.hqCd = leftSrchVal.hqCd;
                    item.hqCdNm = hq.filter(cd => cd.hqCd ===leftSrchVal.hqCd)[0].hqNm;
                    item.agncCd = item.agncCd;
                    item.agncCdNm = item.agncNm;
                })
                setLeftGrid(tmp)
                setLeftGridCol('03');
            }
            // 채널o, 본부o, 지점o
            else if(leftSrchVal.hqCd !== '' && leftSrchVal.hqCd !== '00' && leftSrchVal.agncCd !== '' && leftSrchVal.agncCd !== '00'){
                setLeftGrid([{
                    orgChnlCd:leftSrchVal.orgChnlCd,
                    orgChnlNm:commonCodeDtl.filter(cd => cd.cdVal === leftSrchVal.orgChnlCd)[0].cmnCdNm,
                    hqCd:leftSrchVal.hqCd,
                    hqCdNm:hq.filter(cd => cd.hqCd ===leftSrchVal.hqCd)[0].hqNm,
                    agncCd:leftSrchVal.agncCd,
                    agncCdNm:agency.filter(cd => cd.agncCd === leftSrchVal.agncCd)[0].agncNm
                }])
                setLeftGridCol('03');
            }
            else{
                // 채널o,본부x,지점x
                setLeftGrid([{
                    orgChnlCd:leftSrchVal.orgChnlCd,
                    orgChnlNm:commonCodeDtl.filter(cd => cd.cdVal === leftSrchVal.orgChnlCd)[0].cmnCdNm,
                }])
                setLeftGridCol('01');
            }
        }
        
        // 우측 상품군 목록 조회
        dispatch(getPrdtByChannel({
            orgChnlCd : leftSrchVal.orgChnlCd
        }))
        rightClearSrchInfo();
    }

    // 좌측그리드 체크박스 체크이벤트
    const onLeftChkChange = (e, row) => {
        const {checked, value} = e.target;

        let tmp = [...leftChkRow];
        if(checked){
            tmp.push(row)
        }else{
            tmp.forEach((item, index)=>{
                if(item.rowIndex === row.rowIndex){
                    tmp.splice(index, 1)
                }
            })
        }

        if(tmp.length === leftGrid.length){
            setLeftAllCheck(true)
        }
        else{
            setLeftAllCheck(false);
        }
        setLeftChkRow(tmp);
    }

    const onHeaderCheckboxChange = (e, column) => {
        const {checked} = e.target;

        if(column.title === 'rightChkBox'){
            if(checked){
                setRightAllCheck(true);
                let tmp = [...rightGrid];
                tmp.forEach((item, index)=>{
                    item.rowIndex = index;
                })
                setRightChkRow(tmp);
            }
            else{
                setRightAllCheck(false);
                setRightChkRow([]);
            }
        }
        else{
            if(checked){
                setLeftAllCheck(true);
                let tmp = [...leftGrid];
                tmp.forEach((item, index)=>{
                    item.rowIndex = index
                })
        
                setLeftChkRow(tmp);
            }
            else{
                setLeftAllCheck(false)
                setLeftChkRow([]);
            }
        }
    }

    const onRightSaleChange = (e) => {
        const {name, value} = e.target;

        setRightSrchVal({
            ...rightSrchVal,
            [name] : value
        })
    }

    const onRightSearch = () => {
        if(leftSrchVal.orgChnlCd === '' || leftSrchVal.orgChnlCd === '00'){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '채널을 선택해주세요.',
            }))
            return;
        }

        if(rightSrchVal.hqCd === '00'){
            delete rightSrchVal.hqCd;
        }
        if(rightSrchVal.agncCd === '00'){
            delete rightSrchVal.agncCd;
        }

        dispatch(getProdSaleImpsAgncRegList({
            ...rightSrchVal,
            targetRow : 1,
            rowSize : 1000
        }))
        rightClearSrchInfo();
    }

    const onRightChkChange = (e, row) => {
        const {checked} = e.target;

        let tmp = [...rightChkRow];
        if(checked){
            tmp.push(row);
        }else{
            tmp.forEach((item, index)=>{
                if(item.rowIndex === row.rowIndex){
                    tmp.splice(index, 1)
                }
            })
        }

        if(tmp.length === rightGrid.length){
            setRightAllCheck(true);
        }
        else{
            setRightAllCheck(false);
        }
        setRightChkRow(tmp);
    }

    const onProdSaleQuitMethodChnage = (e) => {
        const {value} = e.target;

        setSaveInfo({
            ...saveInfo,
            ['saleQuitProcMethdCd'] : value
        })
    }

    const onSaleQuitRsnChange = (e) => {
        const {value} = e.target;

        setSaveInfo({
            ...saveInfo,
            ['saleQuitRsn'] : value
        })
    }

    const onSave = () => {
        if(leftChkRow.length < 1){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '저장할 조직을 선택해주세요.',
            }))
            return;
        }

        if(rightChkRow.length < 1){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '저장할 상품을 선택해주세요.',
            }))
            return;
        }

        if(saveInfo.saleQuitStrtDd.trim() === ''
        || saveInfo.saleQuitEndDd.trim() === ''
        || saveInfo.saleQuitProcMethdCd.trim() === ''
        || saveInfo.saleQuitRsn.trim() === ''
        ){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '저장할 정보를 확인해주세요.',
            }))
            return;
        }

        rightChkRow.forEach(item => {
            item.saleQuitEndDd = saveInfo.saleQuitEndDd;
            item.saleQuitProcMethdCd = saveInfo.saleQuitProcMethdCd;
            item.saleQuitRsn = saveInfo.saleQuitRsn;
            item.saleQuitStrtDd = saveInfo.saleQuitStrtDd;
            // item.hqCd = saveInfo.hqCd
            // item.agncCd = saveInfo.agncCd
            item.hqSvcOrgCd = saveInfo.hqCd
            item.agncSvcOrgCd = saveInfo.agncCd
        })
        
        // console.log(rightChkRow);
        dispatch(saveProdSaleImpsAgnc({
            rightChkRow : rightChkRow,
            rightSrchVal : {...rightSrchVal, orgChnlCd : leftSrchVal.orgChnlCd}
        }));

        rightClearSrchInfo();
        setSaveInfo({
            ...saveInfo,
            ['saleQuitStrtDd'] : '',
            ['saleQuitEndDd'] : '',
            ['saleQuitProcMethdCd'] : '',
            ['saleQuitRsn'] : '',
        })
    }
    
    const rightClearSrchInfo = () => {
        setRightChkRow([]);
        setRightGrid([]);
        setRightAllCheck(false);
    }

    return (
        <Layout>
            <div className='con-wrap'>
                <div className='app-wrap'>
                    <div className='app-box'>
                        <div className='con-bottom'>
                            <div className='tit-area'>
								<h2 className='tit-con'>판매불가상품 등록</h2>
							</div> 
                            <div className='col-tbl-wrap pdt-0 mgt-0'>
                                <div className='table-wrap-reg'>
                                    <div className='search-box'>
                                        <UnavailableListBox
                                            label={'채널'}
                                            allVisible={false}
                                            list={channel}
                                            value={leftSrchVal.orgChnlCd}
                                            onChange={(val)=>{
                                                setSearchValBySelect({
                                                    target:'orgChnlCd',
                                                    val
                                                });

                                                dispatch(getHqListByChannel({
                                                    chnlCd : val
                                                }))

                                                // dispatch(prodSaleImpsAgncRegedListClear());
                                            }}
                                        />
                                        <UnavailableListBox
                                            label={'본부'}
                                            allVisible={true}
                                            list={hq}
                                            value={leftSrchVal.hqCd}
                                            onChange={(val)=>{
                                                if(val === '' || val === '00') setIsHqChkAll(false)
                                                else setIsHqChkAll(true)

                                                setSearchValBySelect({
                                                    target:'hqCd',
                                                    val
                                                });

                                                dispatch(getAgencyListByHq({
                                                    chnlCd: leftSrchVal.orgChnlCd,
                                                    hqCd: val,
                                                }))
                                            }}
                                        />
                                        <UnavailableListBox
                                            label={'지점'}
                                            allVisible={isHqChkAll}
                                            list={agency}
                                            value={leftSrchVal.agncCd}
                                            onChange={(val)=>{
                                                setSearchValBySelect({
                                                    target:'agncCd',
                                                    val
                                                });
                                            }}
                                        />
                                        <button className='btn-search' onClick={onLeftSearch}>검색</button>
                                    </div>
                                    <div className='tit-mini mgt-20'>전체 {leftGrid.length}건</div>
                                    <div className='table-wrap table-wrap-scroll'>
                                        <SatDataGrid
                                            columns={LEFT_COLUMN_RENDER[leftGridCol](onLeftChkChange, onHeaderCheckboxChange, leftAllCheck, leftChkRow)}
                                            dataSource={leftGrid}
                                            customStyleClass={'depth1'}
                                            noDataRender={'검색결과가 없습니다.'}
                                        />
                                    </div>
                                </div>

                                <div className='table-wrap-reg'>
                                    <div className='search-box'>
                                        <UnavailableListBox
                                            label={'상품군'}
                                            selVisible={false}
                                            allVisible={true}
                                            list={saleList}
                                            value={rightSrchVal.prodGrpCd}
                                            onChange={(val)=>{
                                                setRightSrchVal({
                                                    ...rightSrchVal,
                                                    ['prodGrpCd'] : val
                                                })
                                            }}
                                        />
                                        <div className='data-group-left'>
                                            <div className='data-area'>
                                                <span className='data-tit'>상품명</span>
                                                <div className='input-wrap input-search'>
                                                    <input
                                                        type={'text'}
                                                        id={'prodNm'}
                                                        name='prodNm'
                                                        className={'input'}
                                                        placeholder={'상품명을 입력하세요.'}
                                                        onChange={onRightSaleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className='btn-search' onClick={onRightSearch}>검색</button>
                                    </div>
                                    <div className='tit-mini mgt-20'>전체 {saleImpsAgncReg.rows}건</div>
                                    <div className='table-wrap table-wrap-scroll'>
                                        <SatDataGrid
                                            columns={RIGHT_COLUMN_RENDER(
                                                onRightChkChange,
                                                onHeaderCheckboxChange,
                                                rightAllCheck,
                                                rightChkRow
                                            )}
                                            dataSource={rightGrid}
                                            customStyleClass={'depth1'}
                                            noDataRender={'검색결과가 없습니다.'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='tbl-wrap-bottom'>
                                <table className="tbl-sty2">
									<colgroup>
										<col width="20%;"/>
										<col width="30%;"/>
										<col width="20%;"/>
										<col width="30%;"/>
									</colgroup>
									<tbody>
										<tr>
											<th>시작일자</th>
											<td>
                                                <SatDatePicker
                                                    viewIcon={true}
                                                    value={saveInfo.saleQuitStrtDd}
                                                    onChange={(value)=>{
                                                        if( saveInfo.saleQuitEndDd !== '' 
                                                        &&  Number(value) > Number(saveInfo.saleQuitEndDd)
                                                        ){
                                                            dispatch(showModal({
                                                                visible : true,
                                                                type    : 'info',
                                                                msg     : '시작일자와 종료일자를 확인해주세요.',
                                                            }))
                                                            return;
                                                        }

                                                        setSaveInfo({
                                                            ...saveInfo,
                                                            saleQuitStrtDd : value
                                                        })
                                                    }}
                                                />
											</td>
											<th>종료일자</th>
											<td>
                                                <SatDatePicker
                                                    viewIcon={true}
                                                    value={saveInfo.saleQuitEndDd}
                                                    onChange={(value)=>{
                                                        if(saveInfo.saleQuitStrtDd !== '' 
                                                        && Number(saveInfo.saleQuitStrtDd) > Number(value)
                                                        ){
                                                            dispatch(showModal({
                                                                visible : true,
                                                                type    : 'info',
                                                                msg     : '시작일자와 종료일자를 확인해주세요.',
                                                            }))
                                                            return;
                                                        }

                                                        setSaveInfo({
                                                            ...saveInfo,
                                                            saleQuitEndDd : value
                                                        })
                                                    }}
                                                />
											</td>
										</tr>
										<tr>
											<th>사유</th>
											<td colSpan="3">
												<div className="form-box">
													<div className="sel-group">
														<select value={saveInfo.saleQuitProcMethdCd} onChange={onProdSaleQuitMethodChnage}>
															<option value="">상품판매불가처리방법 선택</option>
                                                            {prodSaleQuitMethod.map((item, index)=>(
                                                                <option
                                                                    key={`prodSale_${index}`}
                                                                    value={item.cdVal}
                                                                >{item.cmnCdNm}
                                                                </option>
                                                            ))}
														</select>
													</div>
													<div className="input-wrap">
														<input type="text" id="text1" className="input" placeholder="사유를 입력하세요." 
                                                            value={saveInfo.saleQuitRsn} onChange={onSaleQuitRsnChange}
                                                        />
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
                            </div>
                        </div>

                        <div className='btn-area-jb'>
                            <ul className='file-list'>
                                <li>
                                    <button className='btn-m cancel'onClick={() => history.goBack()}>취소</button>
                                </li>
                                <li>
                                    <button className='btn-m save' onClick={onSave}>저장</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ManagementSystemUnavailableReg;